var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"type":"flex","justify":"end"}},_vm._l((_vm.options),function(qr,i){return _c('el-button',{key:("emoji-" + i),staticClass:"emoji-preview",attrs:{"circle":""},domProps:{"textContent":_vm._s(qr.text)}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }